import { inject, Injectable } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { AuDialogService } from '@core/services/au-dialog.service';
import { TranslateService } from '@tolgee/ngx';

@Injectable({
	providedIn: 'root',
})
export class CmmsTableSelectionService<T> {
	private selections: SelectionModel<T>;
	private dialogService = inject(AuDialogService);
	private translateService = inject(TranslateService);

	setSelections(selections: SelectionModel<T>) {
		this.selections = selections;
	}

	getSelections() {
		return this.selections;
	}

	bulkCheckboxSelectionHandler(value: { data: T[]; isAllSelected: boolean }) {
		if (value.isAllSelected || (this.selections.hasValue() && !value.isAllSelected)) {
			this.selections.clear();
		} else {
			value.data.forEach(entity => this.selections.toggle(entity));
		}
	}

	checkboxSelectionHandler(data) {
		this.selections.toggle(data);
	}

	deleteConfirmationDialog(
		itemType: string,
		idKey: string = 'pk',
		callbackFn: (pks: string[]) => void
	) {
		const pks = this.selections.selected.map(i => i[idKey]);

		if (!pks.length) {
			throw new Error('No private keys extracted from selection');
		}

		const dialogRef = this.dialogService.openDeleteDialog({
			itemType: this.translateService.instant(itemType),
			description: this.translateService.instant('delete_confirmation_plural', {
				count: pks.length,
				type: this.translateService.instant(itemType),
			}),
		});

		this.dialogService.closedByEnter(dialogRef).subscribe(confirm => {
			if (confirm) {
				this.selections.clear();
				callbackFn(pks);
			}
		});
	}

	clearCheckboxSelections() {
		this.selections.clear();
	}
}
